import { Modal, ModalBody } from "reactstrap";
import "react-quill/dist/quill.snow.css";

const MMThreedNoWinner = (props) => {
  return (
    <Modal isOpen={true} style={{ maxWidth: "400px" }}>
      <ModalBody className="pt-5">
        <p className="text-center fs-3" style={{ lineHeight: "40px" }}>
          အလျော်အစားပြုလုပ်ရန် ထီပေါက်သူမရှိပါခင်ဗျာ။
        </p>
        <div className="d-flex justify-content-center">
        <button
          className="btn btn-primary py-1 mt-1"
          onClick={() => props.setCloseNoWinner(false)}
        >
          ဟုတ်ကဲ့
        </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default MMThreedNoWinner;
